import { Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import routes from '../../../../Routes';
export const Loader = () => <div id='loading'></div>;

const ProtectedRoutes = ({ role, showVoc }) => {
  return (
    <Switch>
      <Suspense fallback={<Loader />}>
        {routes.map(
          ({ component: Component, path, exact, roles, redirect }) => (
            <Route
              path={`/${path}`}
              key={path}
              exact={exact}
              render={({ location }) => {
                if (redirect) {
                  let r = redirect.find((x) => x.roles.indexOf(role) != -1);
                  if (r) {
                    return <Redirect to={{ pathname: r.path }} />;
                  }
                }
                if (roles.indexOf(role) === -1) {
                  // role not authorised so redirect to home page
                  return <Redirect to={{ pathname: '/unauthorized' }} />;
                }
                if (path == 'voc' && !showVoc) {
                  return <Redirect to={{ pathname: '/unauthorized' }} />;
                }
                return <Component />;
              }}
            ></Route>
          )
        )}
      </Suspense>
    </Switch>
  );
};
export default ProtectedRoutes;
